/* eslint-disable import/no-cycle */
import { Login } from "../pages/login";
import { Logout } from "../pages/logout";
import { Route } from "../types/route";

export const publicRoutes: Route[] = [
  {
    key: "router-login",
    title: "Login",
    access: "Login",
    description: "Login",
    component: Login,
    path: "/login",
    isEnabled: true,
    appendDivider: true,
  },
  {
    key: "router-logout",
    title: "Logout",
    access: "Logout",
    description: "Logout",
    component: Logout,
    path: "/logout",
    isEnabled: true,
    appendDivider: true,
  },
];
